/**
 * invoiceFiles.js: IDI-484 (ruled by Adrian, Q-45/Q-46, 2026-10-11).
 *
 * An invoice's files are stored on its JOB, in `job.documents[]`, as
 * AttachmentRefs carrying `sourceType: 'invoice'` and `sourceId: <invoice id>`.
 * The invoice lists its own files from the job; the job's Files tab labels
 * them "Invoice I-…". Internal only at launch: never sent to the customer.
 *
 * A file attached while CREATING an invoice has no invoice id yet. It is
 * stored on the job as an invoice file with no `sourceId`, and the create
 * request lists its attachment id so the server can claim it for the new
 * invoice (cmd/invoices claimInvoiceAttachments).
 */
import { isAttachmentRef } from '../../utils/attachmentEntry';

/** The job's files that belong to `invoiceId`. */
export function invoiceFilesFromJob(documents, invoiceId) {
  if (!invoiceId || !Array.isArray(documents)) return [];
  return documents.filter((d) => isAttachmentRef(d)
    && d.sourceType === 'invoice'
    && d.sourceId === invoiceId);
}

/**
 * The label the job's Files tab shows under an invoice file. `invoicesById`
 * maps invoice id -> invoice (for its number); an unknown or unclaimed one
 * still reads as an invoice file.
 */
export function invoiceFileLabel(doc, invoicesById = {}) {
  if (!doc || doc.sourceType !== 'invoice') return null;
  const inv = doc.sourceId ? invoicesById[doc.sourceId] : null;
  const number = inv && (inv.invoiceNumber || inv.invoice_number);
  return number ? `Invoice ${number}` : 'Invoice';
}
